<template>
  <ax-dialog 
    ref="dialog"
    title="Percentile selection" 
    icon="mdi-select-compare" 
    tooltip="Percentile selection"
    size="medium" 
    @submitted="onSubmit"
    @shown="onShow"
  >
    <template slot="content">
      <v-card-text>
        <p class="text-subtitle-1">Please select range of percentiles to use for limiting the selection</p>
        <v-range-slider v-model="config.range" :min="0" :max="100" :step="step" thumb-label>
          <template v-slot:prepend>
            <v-text-field
              hint="Lower limit" persistent-hint
              :value="config.range[0]"
              class="mt-0 pt-0"
              single-line
              type="number"
              hide-spin-buttons
              style="width: 70px"
              @change="$set(config.range, 0, $event)"
            ></v-text-field>
          </template>
          <template v-slot:append>
            <v-text-field
              hint="Upper limit" persistent-hint
              :value="config.range[1]"
              class="mt-0 pt-0"
              single-line
              type="number"
              hide-spin-buttons
              style="width: 70px"
              @change="$set(config.range, 1, $event)"
            ></v-text-field>
          </template>
        </v-range-slider>
        <v-row>
          <v-col cols="auto"><v-checkbox v-model="config.select" label="Create a new group" hide-details /></v-col>
          <v-col><v-checkbox v-model="config.invert" label="Invert selection" hide-details /></v-col>
        </v-row>
      </v-card-text>
    </template>
    <template slot="submit_text"> {{ !config.select ? 'Select' : 'Create' }} </template>
  </ax-dialog>
</template>
<script>
import AxDialog from '@/components/dialog'
export default {
  name: "dlgPercentiles",
  props: {
    min: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    step: { type: Number, default: 1 },
  },
  components: { 
    AxDialog
  },
  data() {
    return {
      config: {
        range: [this.min, this.max],
        select: false,
        invert: false,
      },
      rules: {}
    }
  },
  methods: {
    onShow() {
      this.rules = {}
    },
    onSubmit() {
      this.rules = {
        required: [
          v => !!v || 'Required',
          v => !this.isEmpty(v)
        ]
      }
      this.$nextTick(() => {
        //manually trigger Vuetify validation
        if (this.$refs.dialog.$refs.form.validate()) {
          this.$refs.dialog.show = false
          this.$emit('submitted', JSON.parse(JSON.stringify(this.config)))
        }
      })
    }
  }
}
</script>